<template>

  <div class="separated-date-time text-body06-regular">

    <div class="date-time-wrapper">
      <label class="date-time-label">{{ $t('message.pickUpDate') }}</label>
      <div class="date-time-row">
        <div class="separated-date-time-symbol" :data-target="targetDate" :data-toggle="targetDate">
          <img class="separated-date-icon" src="@/assets/icon/v3/date.svg" alt="cal">
        </div>
        <input
            type="text"
            :placeholder="datelabel"
            class="separated-date-input"
            :data-target="targetDate"
            ref="dateRef"
            readonly
        />
      </div>
    </div>

    <div class="date-time-wrapper">
      <label class="date-time-label">{{ $t('message.pickUpTime') }}</label>
      <div class="date-time-row-time">
        <div class="separated-date-time-symbol" :data-target="targetTime" :data-toggle="targetTime">
          <img class="separated-time-icon" src="@/assets/icon/v3/time.svg" alt="clock">
        </div>
        <input
            type="text"
            :placeholder="timelabel"
            class="separated-time-input"
            :data-target="targetTime"
            ref="timeRef"
            readonly
        />
      </div>
    </div>

  </div>

</template>

<script>


import {DateTime, Namespace, TempusDominus} from '@eonasdan/tempus-dominus';
import dayjs from 'dayjs';


export default {
  name: "DateTimeInputNativeSeparated",
  props: ["value", "datelabel", "timelabel", "id", "minDate", "maxDate", "location", "widgetType", "bookViewFilter"],
  watch: {
    minDate: function (newVal, oldVal) {
      if (!this.pickerDate && !this.pickerTime) return;
      this.pickerDate.updateOptions({
        restrictions: {
          minDate: this.minDate
        },
      });

    },
    maxDate: function (newVal, oldVal) {

      if (!this.pickerDate && !this.pickerTime) return;
      this.pickerDate.updateOptions({
        restrictions: {
          maxDate: newVal
        },
      });
    },
    value: function (newVal, oldVal) {
      console.log("come here watch value");
      if (!this.pickerDate && !this.pickerTime) return;
      if (this.widgetType === 0 || this.widgetType === 1) {
        this.updateDateTimePickersAndOpeingHours(newVal, oldVal)
      }
    },
    location: function (newVal, oldVal) {
      if (this.widgetType === 0 || this.widgetType === 1) {
        if (newVal !== oldVal) {

          this.updatePickUpTimeBasedOnLocationAndDate(newVal, this.localJustDate);
          this.getHolidaysClosedForBusiness(newVal);
          this.getWeekdayClosedForBusiness(newVal);
        }
      }

      this.updateDisabledIntervals();

    },
    localJustDate: function (newVal, oldVal) {
      if (this.widgetType === 0 || this.widgetType === 1) {
        if (newVal !== oldVal) { //newVal is 2029-07-24 string
          console.log("come here watch just date newVal, oldVal ", newVal, oldVal)
          this.updatePickUpTimeBasedOnLocationAndDate(this.localLocation, newVal);//newVal is string 2029-06-13
        }
      }
    }
  },
  data() {
    return {
      pickerDate: null,
      pickerTime: null,
      disabledIntervals: [],
      /*      selectedTime: '',
            timeOptions: [],*/
    };
  },
  created() {
    /*    console.log(" hehe he he he ha")
        this.timeOptions = this.generateTimeOptions();*/
  },
  mounted() {
    console.log(" hehe he he he ")
    this.initializeDatePicker();

    this.initializeTimePicker();
    this.updateDisabledIntervals();

    },
  beforeUnmount() {
    if (this.pickerDate) {
      this.pickerDate.dispose();
    }
    if (this.pickerTime) {
      this.pickerTime.dispose();
    }
  },
  computed: {

    idInternal: {
      get() {
        return this.id;
      },
    },
    targetTime: {
      get() {
        return "#" + this.idInternal + "time";
      },
    },
    targetDate: {
      get() {
        return "#" + this.idInternal + "date";
      },
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-date", newValue);
      },
    },
    localJustDate: {
      get() {
        return dayjs(this.value).format('YYYY-MM-DD');//2024-05-13 string
      }
    },
    localLocation: {
      get() {
        return this.location;
      }
    }

  },
  methods: {

    /*    generateTimeOptions() {
          console.log(">>>> come here timeslots")
          const timeSlots = [];
          let currentTime = dayjs('00:00', 'HH:mm');
          while (currentTime.isBefore(dayjs('23:59', 'HH:mm'))) {
            console.log("Adding time:", currentTime.format('HH:mm'));
            timeSlots.push({ value: currentTime.format('HH:mm'), text: currentTime.format('HH:mm') });
            currentTime = currentTime.add(30, 'minutes');
          }
          console.log(">>>> time slots is:",timeSlots)
          return timeSlots;
        },

        updateTimePicker(newTime) {
          console.log(" update time picker newtime",newTime);
          console.log(" this date is",this.internalValue,this.pickerDate.dates);
          const [hours, minutes] = newTime.split(':').map(Number);
          this.pickerTime.dates.set(this.pickerTime.dates.lastPicked, {
            hours,
            minutes,
            seconds: 0,
          });
        },*/

      handleDateTimePickerFocus(event) {
          console.log("TIMEPICKER EVENT", event)
          const height = document.body.scrollHeight;
          const datepicker = document.querySelector(".tempus-dominus-widget");
          let additionalHeight = 0;

          if (datepicker) {
            additionalHeight = 20; // Adjust for the date picker height
          }

      //    console.log(">>> iframe date time picker height:", height);
       //   console.log("$$$$$$ date picker height:", additionalHeight);

          let calculatedHeight = height;
          if(event =="show"){
            calculatedHeight = height + calculatedHeight
          }
          if(event == "hide"){
            calculatedHeight = height - additionalHeight;
          }

          // Post the updated height to the parent
          window.parent.postMessage({ iframeHeight: calculatedHeight }, '*');

    },

    initializeDatePicker() {
      this.pickerDate = new TempusDominus(this.$refs.dateRef, {
        useCurrent: false,
        display: {
          viewMode: 'calendar',
          components: {
            clock: false,
            hours: false,
            minutes: false,
            seconds: false,
          },
/*         placement:'top',*/
        },
        restrictions: {
          minDate: this.minDate || new Date(),
          disabledDates: [],
        },
        localization: {
          format: "dd/MM/yyyy",
          startOfTheWeek: 1,
          locale: "en",
        },
      });

      this.pickerDate.subscribe(Namespace.events.show, () => {
        console.log("what: ", Namespace.events.show);
        this.handleDateTimePickerFocus("show"); // Trigger iframe resize
      });

      this.pickerDate.subscribe(Namespace.events.hide, () => {
        console.log("what: ", Namespace.events.hide);
        this.handleDateTimePickerFocus("hide"); // Trigger iframe resize
      });

      this.$refs.dateRef.addEventListener(Namespace.events.change, (e) => {

        if (e.detail.date) {
          this.internalValue = e.detail.date;

        }
      });

      if (this.internalValue) {
        this.pickerDate.dates.setValue(DateTime.convert(this.internalValue));
      }
    },
    initializeTimePicker() {
      if (this.pickerTime) {
        this.pickerTime.dispose();
      }

      this.pickerTime = new TempusDominus(this.$refs.timeRef, {
        useCurrent: false,
        display: {
          viewMode: 'clock',
          components: {
            calendar: false,
            date: false,
            month: false,
            year: false,
            decades: false,
          },/*
          buttons: {
            today: true,
            clear: true,
            close: true
          },
          toolbarPlacement: 'top',*/
       /*   placement:'bottom'*/
        },
        restrictions: {
          minDate: this.minDate || new Date(),
          disabledTimeIntervals: this.disabledIntervals,
        },
        localization: {
          format: "HH:mm",
          hourCycle: 'h23'
        },
        stepping: 15,
      });

      this.pickerTime.subscribe(Namespace.events.show, () => {
        console.log("what: ", Namespace.events.show);
        this.handleDateTimePickerFocus("show"); // Trigger iframe resize
      });

      this.pickerTime.subscribe(Namespace.events.hide, () => {
        console.log("what: ", Namespace.events.hide);
        this.handleDateTimePickerFocus("hide"); // Trigger iframe resize
      });
      this.$refs.timeRef.addEventListener(Namespace.events.change, (e) => {
        if (e.detail.date) {
          this.internalValue = e.detail.date;
        }
      });

      if (this.internalValue) {
        this.pickerTime.dates.setValue(DateTime.convert(this.internalValue));
      }
    },
    getTheWeekdayFromDate(datestring) {

      const dayOfWeek = dayjs(datestring).day();
      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const weekdayName = weekdays[dayOfWeek];
      return weekdayName;
    },

    parseTimeString(timeString) {
      // Assuming the times are in the format HHmm
      return dayjs().hour(parseInt(timeString.substring(0, 2), 10)).minute(parseInt(timeString.substring(2, 4), 10));
    },
    calculateStartTimeForCurrentDate(starttimeStr, endtimeStr) {

      const pickuptimeStr = dayjs(this.minDate).format("HHmm");

      console.log("Jiena starttimeStr,endtimeStr", starttimeStr, endtimeStr);
      console.log("Jiena this.minDate", this.minDate);
      console.log("Jiena pickuptimeStr", pickuptimeStr);

      const starttimeFromStr = this.parseTimeString(starttimeStr);
      const endtimeFromStr = this.parseTimeString(endtimeStr);
      const pikuptimeFromStr = this.parseTimeString(pickuptimeStr);
      const isBetween = pikuptimeFromStr.isAfter(starttimeFromStr) && pikuptimeFromStr.isBefore(endtimeFromStr);
      const isAfter = pikuptimeFromStr.isAfter(endtimeFromStr);
      const isBefore = pikuptimeFromStr.isBefore(starttimeFromStr);
      if (isBefore) {
        return starttimeStr;
      }
      if (isBetween) {
        return pickuptimeStr;
      }
      if (isAfter) {
        return endtimeStr;
      } else {
        return starttimeStr;
      }
    },
    updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, justdate) {
      console.log("LLLL come here!!", pickUpLocation, justdate)

      let startTimeForCurrentDate = '';


      const currentDateFormatted = justdate;//2024-06-16

      const weekday = this.getTheWeekdayFromDate(currentDateFormatted);


      if (pickUpLocation) {
        const openingTimes = pickUpLocation?.openingTimes;
        const holidays = pickUpLocation?.holidays;

        if (!openingTimes?.length && !holidays?.length) {
          startTimeForCurrentDate = "0800";
        } else {
          if (this.widgetType === 0) {
            const openingDay = openingTimes?.filter(ot => (ot.timeType === this.widgetType && ot.description === weekday));
            const matchedOpeningDay = openingDay[0];

            if (matchedOpeningDay?.startTime[0] === '0001' && matchedOpeningDay?.endTime[0] === "2359") {//means this day is closed for business
              //handle the scenario that all sundays for example are closed for business

              const nextWeekday = dayjs(currentDateFormatted).add(1, 'day').format('YYYY-MM-DD');

              setTimeout(() => {
                this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextWeekday);
              }, 0);

            } else {
              startTimeForCurrentDate = matchedOpeningDay?.startTime[0];
            }


            if (holidays?.length) {
              holidays?.filter(holiday => holiday.timeType === this.widgetType).map(holiday => {
                const dateFormated = dayjs(holiday.date).format("YYYY-MM-DD");//e.g. 2024-06-18
                if (dateFormated === currentDateFormatted) {

                  //when this holiday is set to 0001-2359, means this date is closed for business, then it should not show this any time in this day, show next days start time
                  if (holiday.startTime[0] === '0001' && holiday.endTime[0] === "2359") {
                    const nextDay = dayjs(holiday.date).add(1, 'day').format("YYYY-MM-DD");


                    // Delay the recursive function call using setTimeout
                    setTimeout(() => {
                      this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextDay);
                    }, 50);

                    return;
                  } else {
                    startTimeForCurrentDate = holiday.startTime[0];
                  }

                }
              })
            }
            if (startTimeForCurrentDate) {
              const newHours = parseInt(startTimeForCurrentDate?.substring(0, 2));
              const newMinutes = parseInt(startTimeForCurrentDate?.substring(2, 4));
              const calculatedStartingDateTime = (new Date(currentDateFormatted));
              calculatedStartingDateTime.setHours(newHours);
              calculatedStartingDateTime.setMinutes(newMinutes);
              console.log(" !!!! come here, calculatedStartingDateTime", calculatedStartingDateTime)

              this.internalValue = calculatedStartingDateTime;
              console.log(" !!!! come here,  this.internalValue", this.internalValue)
            }

          } else if (this.widgetType === 1) {
            const openingDay = openingTimes?.filter(ot => (ot.timeType === this.widgetType && ot.description === weekday));
            const matchedOpeningDay = openingDay[0];

            if (matchedOpeningDay?.startTime[0] === '0001' && matchedOpeningDay?.endTime[0] === "2359") {
              //handle the scenario that all sundays for example are closed for business

              const nextWeekday = dayjs(currentDateFormatted).add(1, 'day').format('YYYY-MM-DD');

              setTimeout(() => {
                this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextWeekday);
              }, 0);

            } else {
              //startTimeForCurrentDate = matchedOpeningDay?.startTime[0];
              let starttimeStr = '';
              let endtimeStr = '';
              if (matchedOpeningDay?.startTime[0] == "0000") {
                starttimeStr = "0005";
              }
              if (matchedOpeningDay?.endTime[0] == "0000") {
                endtimeStr = "2355";
              } else {
                starttimeStr = matchedOpeningDay?.startTime[0];
                endtimeStr = matchedOpeningDay?.endTime[0];
              }
              startTimeForCurrentDate = this.calculateStartTimeForCurrentDate(starttimeStr, endtimeStr);
            }


            if (holidays?.length) {
              holidays?.filter(holiday => holiday.timeType === this.widgetType).map(holiday => {
                const dateFormated = dayjs(holiday.date).format("YYYY-MM-DD");//e.g. 2024-06-18
                if (dateFormated === currentDateFormatted) {

                  //when this holiday is set to 0001-2359, means this date is closed for business, then it should not show this any time in this day, show next days start time
                  if (holiday.startTime[0] === '0001' && holiday.endTime[0] === "2359") {
                    const nextDay = dayjs(holiday.date).add(1, 'day').format("YYYY-MM-DD");


                    // Delay the recursive function call using setTimeout
                    setTimeout(() => {
                      this.updatePickUpTimeBasedOnLocationAndDate(pickUpLocation, nextDay);
                    }, 50);

                    return;
                  } else {
                    //startTimeForCurrentDate = holiday.startTime[0];
                    let startTimeStr = '';
                    let endTimeStr = '';
                    if (holiday.startTime[0] == "0000") {
                      startTimeStr = "0005";
                    }
                    if (holiday.endTime[0] == "0000") {
                      endTimeStr = "2355";
                    } else {
                      startTimeStr = holiday.startTime[0];
                      endTimeStr = holiday.endTime[0];
                    }

                    startTimeForCurrentDate = this.calculateStartTimeForCurrentDate(startTimeStr, endTimeStr);

                  }

                }
              })
            }
            if (startTimeForCurrentDate) {
              const newHours = parseInt(startTimeForCurrentDate?.substring(0, 2));
              const newMinutes = parseInt(startTimeForCurrentDate?.substring(2, 4));
              let calculatedStartingDateTime = (new Date(currentDateFormatted));
              calculatedStartingDateTime.setHours(newHours);
              calculatedStartingDateTime.setMinutes(newMinutes);
              console.log(" !!!! come here, calculatedStartingDateTime", calculatedStartingDateTime)

              this.internalValue = calculatedStartingDateTime;
              console.log(" !!!! come here,  this.internalValue", this.internalValue)
            }

          }
        }
      }
    },
    setTimeToBoundaryIfNotInsideValidPeriod(newVal) {
      console.log("come here 4  newVal to calculate:", newVal);
      const disabledIntervals = this.disabledIntervals;
      const newtime = newVal;
      for (let i = 0; i < disabledIntervals.length; i++) {
        const interval = disabledIntervals[i];
        const from = interval.from;
        const to = interval.to;

        console.log("come here 4  from,to,newtime:", from, to, newtime);
        if (newtime.isBetween(from, to, null, '()')) {
          console.log("come here 4 between true");
          if (i === 0) {
            console.log("come here 4 i===0 :", interval.to);
            return interval.to
          } else {
            console.log("come here 4 i!==0 :", interval.from);
            return interval.from
          }

        } else {
          console.log("come here 4 not between false i is:", i)
        }
      }
      return newVal;
    },
    updateDateTimePickersAndOpeingHours(newVal, oldVal) {
      console.log("this.widgetType--> newVal-->oldVal", this.widgetType, newVal, oldVal);
      const format = "ddd MMM DD YYYY HH:mm:ss [GMT]Z [(]zzzz[)]";
      const dateNew = dayjs(newVal);
      const dateOld = dayjs(oldVal);

      const dateOnlyNew = dateNew.format("YYYY-MM-DD");
      const dateOnlyOld = dateOld.format("YYYY-MM-DD");
      const timeOnlyNew = dateNew.format("HH:mm:ss");
      const timeOnlyOld = dateOld.format("HH:mm:ss");

      const dateChanged = dateOnlyNew !== dateOnlyOld;
      const timeChanged = timeOnlyNew !== timeOnlyOld;
      if (dateChanged && timeChanged) {
        console.log("come here 1");
        this.pickerDate.dates.setValue(DateTime.convert(newVal));

        console.log("come here 2");
        this.pickerTime.dates.setValue(DateTime.convert(newVal));
        this.updateDisabledIntervals();
      } else if (dateChanged) {
        console.log("come here 3");
        this.pickerDate.dates.setValue(DateTime.convert(newVal));
        this.updateDisabledIntervals();
      } else if (timeChanged) {
        console.log("come here 4");
        this.pickerTime.dates.setValue(DateTime.convert(newVal));


        const newTime = this.setTimeToBoundaryIfNotInsideValidPeriod(newVal);
        this.pickerTime.dates.setValue(DateTime.convert(newTime));

      } else {
        console.log("date and time is not changed!")
      }
    },


    isSameDay: function (date1, date2) {
      return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
    },
    whichWeekDay: function (date) {

      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      return weekdays[date.getDay()];// date is new Date()format

    },


    // when for a certain location, the holidays array is not empty, and for a certain date the startTime[0] === "0001" and endTime[0] === "2359",
    // it means this holiday is closed for business, then add this date to disabledDates array in tempus
    getHolidaysClosedForBusiness(location) {

      const holidays = location?.holidays;
      let datesClosedForBusiness = {};
      if (holidays?.length > 0) {
        holidays?.map((holiday) => {
          if (holiday.startTime[0] === "0001" && holiday.endTime[0] === "2359") {
            if (!datesClosedForBusiness[holiday.timeType]) {
              datesClosedForBusiness[holiday.timeType] = [];
            }
            const date = dayjs(holiday.date).toDate();//utc string to GMT+2
            datesClosedForBusiness[holiday.timeType].push(date);
          }
        })
      }
      if (datesClosedForBusiness[this.widgetType]) {
        this.pickerDate.updateOptions({
          restrictions: {
            disabledDates: datesClosedForBusiness[this.widgetType]
          }
        });
      }
    },

    getWeekDayNumber(weekday) {
      const weekdayMapping = {
        'sunday': 0,
        'monday': 1,
        'tuesday': 2,
        'wednesday': 3,
        'thursday': 4,
        'friday': 5,
        'saturday': 6
      };
      const day = weekday.toLowerCase();
      return weekdayMapping[day];

    },

    getWeekdayClosedForBusiness(location) {

      const openingTimes = location?.openingTimes;
      let weekdayClosedForBusiness = {};
      if (openingTimes?.length > 0) {
        openingTimes.map((ot) => {
          if (ot.startTime[0] === "0001" && ot.endTime[0] === "2359") {
            if (!weekdayClosedForBusiness[ot.timeType]) {
              weekdayClosedForBusiness[ot.timeType] = [];
            }
            const weekday = ot.description;// e.g. Sunday
            const weekdayNumber = this.getWeekDayNumber(weekday);
            weekdayClosedForBusiness[ot.timeType].push(weekdayNumber);
          }
        })
      }
      if (weekdayClosedForBusiness[this.widgetType]) {
        this.pickerDate.updateOptions({
          restrictions: {
            daysOfWeekDisabled: weekdayClosedForBusiness[this.widgetType]
          }
        });
      }

    },

    getOneDisabledInterval(startTime, endTime) {

      const startHour = parseInt(startTime.substring(0, 2));
      const startMinute = parseInt(startTime.substring(startTime.length - 2));

      const endHour = parseInt(endTime.substring(0, 2));
      const endMinute = parseInt(endTime.substring(endTime.length - 2));
      let fromTime, toTime;
      if (startTime === endTime) {
        fromTime = dayjs(this.value).set('hour', startHour).set('minute', startMinute).subtract(5, 'minute').toDate();
        toTime = dayjs(this.value).set('hour', endHour).set('minute', endMinute).add(5, 'minute').toDate();
      } else {
        fromTime = dayjs(this.value).set('hour', startHour).set('minute', startMinute).toDate();
        toTime = dayjs(this.value).set('hour', endHour).set('minute', endMinute).toDate();
      }

      const result = {fromTime, toTime};
      return result;
      /* }*/
    },
    getIntervalsArray(firstValidIntervals, secondValidIntervals) {
      const midnightAm = dayjs(this.value).set('hour', 0 - 1).set('minute', 0).toDate();
      const midnightPm = dayjs(this.value).set('hour', 24).set('minute', 0).toDate();
      const disabledIntervals = [];
      let disabledInterval1 = {};
      let disabledInterval2 = {};
      let disabledInterval3 = {};
      const beforefromtime1 = dayjs(firstValidIntervals.fromTime).subtract(1, 'minute');
      const formatBeforefromtime1 = beforefromtime1.toDate();
      const beforefromtime2 = dayjs(secondValidIntervals.fromTime).subtract(1, 'minute');
      const formatBeforefromtime2 = beforefromtime2.toDate();
      disabledInterval1 = {from: midnightAm, to: formatBeforefromtime1};
      disabledInterval2 = {from: firstValidIntervals.toTime, to: formatBeforefromtime2};
      disabledInterval3 = {from: secondValidIntervals.toTime, to: midnightPm};

      const firstPeriodIsAPoint = dayjs(firstValidIntervals.fromTime).isSame(dayjs(firstValidIntervals.toTime))
      const secondPeriodIsAPoint = dayjs(secondValidIntervals.fromTime).isSame(dayjs(secondValidIntervals.toTime))

      if (!firstPeriodIsAPoint && secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: firstValidIntervals.fromTime};
        disabledInterval2 = {
          from: firstValidIntervals.toTime,
          to: dayjs(secondValidIntervals.fromTime).subtract(5, 'minute').toDate()
        };
        disabledInterval3 = {from: dayjs(secondValidIntervals.toTime).add(5, 'minute').toDate(), to: midnightPm};
      }
      if (firstPeriodIsAPoint && !secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: dayjs(firstValidIntervals.fromTime).subtract(5, 'minute').toDate()};
        disabledInterval2 = {
          from: dayjs(firstValidIntervals.toTime).add(5, 'minute').toDate(),
          to: secondValidIntervals.fromTime
        };
        disabledInterval3 = {from: secondValidIntervals.toTime, to: midnightPm};
      }
      if (firstPeriodIsAPoint && secondPeriodIsAPoint) {// todo needs test
        disabledInterval1 = {from: midnightAm, to: dayjs(firstValidIntervals.fromTime).subtract(5, 'minute').toDate()};
        disabledInterval2 = {
          from: dayjs(firstValidIntervals.toTime).add(5, 'minute').toDate(),
          to: dayjs(secondValidIntervals.fromTime).subtract(5, 'minute').toDate()
        };
        disabledInterval3 = {from: dayjs(secondValidIntervals.toTime).add(5, 'minute').toDate(), to: midnightPm};
      }
      disabledIntervals.push(disabledInterval1)
      disabledIntervals.push(disabledInterval2)
      disabledIntervals.push(disabledInterval3)
      return disabledIntervals

    },
    getDisabledIntervalFraValidIntervals(validIntervals) {
      //validIntervals:[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2000"}]
      const midnightAm = dayjs(this.value).set('hour', 0 - 1).set('minute', 0).toDate();
      const midnightPm = dayjs(this.value).set('hour', 24).set('minute', 0).toDate();


      if (validIntervals.length == 0) {
        const disabledIntervals = [];
        const timePoint = dayjs(this.value).set('hour', 0).set('minute', 3).toDate(); //could be any time, just need to disable time selection
        const disabledInterval1 = {from: midnightAm, to: timePoint};
        const disabledInterval2 = {from: timePoint, to: midnightPm};
        disabledIntervals.push(disabledInterval1);
        disabledIntervals.push(disabledInterval2);

        return disabledIntervals

      }
      if (validIntervals.length == 1) {


        const disabledIntervals = [];
        const startTime = validIntervals[0].startTime;
        const endTime = validIntervals[0].endTime;

        const result = this.getOneDisabledInterval(startTime, endTime)
        const fromTime = result.fromTime;
        const toTime = result.toTime;

        const beforefromtime = dayjs(fromTime).subtract(1, 'minute');
        const formatBeforefromtime = beforefromtime.toDate();

        const disabledInterval1 = {from: midnightAm, to: formatBeforefromtime};
        const disabledInterval2 = {from: toTime, to: midnightPm};
        disabledIntervals.push(disabledInterval1);
        disabledIntervals.push(disabledInterval2);

        return disabledIntervals
      }

      // handle case where there are 2 validintervals
      if (validIntervals.length == 2) {

        const startTime0 = validIntervals[0].startTime
        const endTime0 = validIntervals[0].endTime


        const startTime1 = validIntervals[1].startTime
        const endTime1 = validIntervals[1].endTime

        const firstStartTime = dayjs(startTime0, 'HHmm')
        const firstEndTime = dayjs(endTime0, 'HHmm')

        const secondStartTime = dayjs(startTime1, 'HHmm')
        const secondEndTime = dayjs(endTime1, 'HHmm')

        if (firstEndTime.isBefore(secondStartTime)) {

          const firstValidIntervals = this.getOneDisabledInterval(startTime0, endTime0)
          const secondValidIntervals = this.getOneDisabledInterval(startTime1, endTime1)
          const disabledIntervals = this.getIntervalsArray(firstValidIntervals, secondValidIntervals)
          return disabledIntervals
        }
        if (secondEndTime.isBefore(firstStartTime)) {

          const firstValidIntervals = this.getOneDisabledInterval(startTime1, endTime1)
          const secondValidIntervals = this.getOneDisabledInterval(startTime0, endTime0)
          return this.getIntervalsArray(firstValidIntervals, secondValidIntervals)
        } else {// otherwise, ignore the second period
          const startTime = validIntervals[0].startTime
          const endTime = validIntervals[0].endTime
          const disabledIntervals = [];
          const {fromTime, toTime} = this.getOneDisabledInterval(startTime, endTime)
          const beforefromtime = dayjs(fromTime).subtract(1, 'minute');
          const formatBeforefromtime = beforefromtime.toDate();
          const disabledInterval1 = {from: midnightAm, to: formatBeforefromtime};
          const disabledInterval2 = {from: toTime, to: midnightPm};
          disabledIntervals.push(disabledInterval1)
          disabledIntervals.push(disabledInterval2)
          return disabledIntervals

        }
      }


    },


    enrichEnabledIntervalsBasedOnOpeningsTimes(openingTimes) {

      return openingTimes?.map(openingTime => {
            const startTimeArray = openingTime?.startTime;
            const endTimeArray = openingTime?.endTime;

            let enabledIntervals = [];//[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2200"}]

            if (!startTimeArray?.length || !endTimeArray?.length) {
              enabledIntervals = [{startTime: "0730", endTime: "1700"}];
            } else {

              const count = Math.min(startTimeArray.length, endTimeArray.length);
              for (let index = 0; index < count; index++) {
                enabledIntervals.push({startTime: startTimeArray[index], endTime: endTimeArray[index]});
              }
            }


            // handling edge cases, specially related to midnight 0000:
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "2359" && interval.endTime == "0000"));
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0000" && interval.endTime == "2359"));
            enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0001" && interval.endTime == "2359"));

            if (enabledIntervals.length === 2 && enabledIntervals[0].startTime === "0000" && enabledIntervals[0].endTime === "0000" &&
                enabledIntervals[1].startTime === "0000" && enabledIntervals[1].endTime === "0000") {
              enabledIntervals = [{startTime: "0005", endTime: "2355"}];
            } else if (enabledIntervals.length === 1 && enabledIntervals[0].startTime === "0000" && enabledIntervals[0].endTime === "0000") {
              enabledIntervals = [{startTime: "0005", endTime: "2355"}];
            } else if (enabledIntervals.length === 2) {
              enabledIntervals = enabledIntervals.filter(interval => !(interval.startTime == "0000" && interval.endTime == "0000"));
              if (enabledIntervals[0] === enabledIntervals[1]) {
                enabledIntervals = enabledIntervals[0];
              }
            }


            //assume there are max two periods in the enabled intervals
            let validIntervals = [];
            if (enabledIntervals.length === 1) {

              //handling edge cases:
              if (enabledIntervals[0].startTime !== '0000' && enabledIntervals[0].endTime === '0000') {
                enabledIntervals[0].endTime = '2355';
              }
              if (enabledIntervals[0].startTime == '0000' && enabledIntervals[0].endTime !== '0000') {
                enabledIntervals[0].startTime = '0005';

              }

              validIntervals = enabledIntervals;

            } else if (enabledIntervals.length > 1) {

              const firstInterval = enabledIntervals[0];
              const secondInterval = enabledIntervals[1];
              const firstStartTime = dayjs(firstInterval.startTime, 'HHmm');
              const firstEndTime = dayjs(firstInterval.endTime, 'HHmm');
              const secondStartTime = dayjs(secondInterval.startTime, 'HHmm');
              const secondEndTime = dayjs(secondInterval.endTime, 'HHmm');
              if (firstEndTime.isBefore(secondStartTime) || secondEndTime.isBefore(firstStartTime)) {
                validIntervals = enabledIntervals;
              } else {
                validIntervals.push(firstInterval);
              }
            }

            const enrichedOpeningTime = {...openingTime, validIntervals};

            return enrichedOpeningTime;

          }
      )

    },

    enrichWithDisabledIntervals(enrichedOpeningTimes) {

      return enrichedOpeningTimes?.map(enrichedOpeningTime => {
        const validIntervals = enrichedOpeningTime.validIntervals;//validIntervals:[{startTime: "0800", endTime: "1600"},{startTime: "1800", endTime: "2200"}]
        // valid intervals to disabled intervals

        const disabledIntervals = this.getDisabledIntervalFraValidIntervals(validIntervals);
        return {...enrichedOpeningTime, disabledIntervals} //disabledIntervals format is toDate format
      })
    },


    createMapFromEnrichedOpeningTimes(enrichedOpeningTimes) {
      return enrichedOpeningTimes?.reduce((acc, openingTime) => {
        if (!acc[openingTime.timeType]) {
          acc[openingTime.timeType] = {};
        }
        acc[openingTime.timeType][openingTime.description] = openingTime.disabledIntervals
        return acc;
      }, {});
    },


    getDisabledIntervalsFromOpeningTimes(locationOpeningTimes) {

      const openingTimes = locationOpeningTimes?.openingTimes;

      if (openingTimes?.length === 0) {
        return {}
      }

      const enrichedWithEnabledIntervals = this.enrichEnabledIntervalsBasedOnOpeningsTimes(openingTimes)

      const enrichedWithDisabledIntervals = this.enrichWithDisabledIntervals(enrichedWithEnabledIntervals)

      return this.createMapFromEnrichedOpeningTimes(enrichedWithDisabledIntervals)
    },


    getDisabledIntervalsFromHolidays(locationOpeningTimes) {
      const holidays = locationOpeningTimes?.holidays;
      if (!holidays) {
        return {};
      }
      const holidaysWithDisabledIntervals = holidays
          .map(holiday => {
            let validIntervals = [];
            validIntervals = [{startTime: holiday.startTime[0], endTime: holiday.endTime[0]}];
            validIntervals = validIntervals.filter(interval => !(interval.startTime == "0001" && interval.endTime == "2359"));// the whole day is closed situation
            const disabledIntervals = this.getDisabledIntervalFraValidIntervals(validIntervals);
            const onlyDate = dayjs(holiday.date).format('YYYY-MM-DD');
            return {...holiday, onlyDate, disabledIntervals};
          })
          .reduce((acc, holiday) => {
            if (!acc[holiday.timeType]) {
              acc[holiday.timeType] = {};
            }
            acc[holiday.timeType][holiday.onlyDate] = holiday.disabledIntervals;
            return acc;
          }, {});

      return holidaysWithDisabledIntervals;
    },

    objectIsEmpty(object) {
      return Object.keys(object).length === 0;
    },


    updateDisabledIntervals: function () {

      this.disabledIntervals = [];
      const updatedDate = this.value; // it is new Date() format

      if (!updatedDate) return;


      let disabledIntervals = []
      const locationOpeningTimes = this.location
      if (locationOpeningTimes?.holidays?.length === 0 && locationOpeningTimes?.openingTimes?.length === 0) {
        const normalValidIntervals = [{startTime: "0600", endTime: "2200"}]
        disabledIntervals = this.getDisabledIntervalFraValidIntervals(normalValidIntervals)

      } else {
        const updatedDateToWeekDay = this.whichWeekDay(updatedDate);
        const disabledIntervalsByWeekday = this.getDisabledIntervalsFromOpeningTimes(locationOpeningTimes)
        const disabledIntervalsByHoliday = this.getDisabledIntervalsFromHolidays(locationOpeningTimes)


        if (this.widgetType === 0 || this.widgetType === 1) {
          if (!this.objectIsEmpty(disabledIntervalsByHoliday)) {
            disabledIntervals = disabledIntervalsByWeekday ? disabledIntervalsByWeekday[this.widgetType][updatedDateToWeekDay] : []

            let updatedDateFormatted = dayjs(updatedDate).format('YYYY-MM-DD');

            let disabledIntervalByHoliday = disabledIntervalsByHoliday[this.widgetType][updatedDateFormatted]
            if (disabledIntervalByHoliday) {
              disabledIntervals = disabledIntervalByHoliday
            }
          } else if (this.objectIsEmpty(disabledIntervalsByHoliday)) {
            disabledIntervals = disabledIntervalsByWeekday ? disabledIntervalsByWeekday[this.widgetType][updatedDateToWeekDay] : []

          }
        }
      }
      this.disabledIntervals = disabledIntervals;
      console.log("come here disabledIntervals for this day is ", disabledIntervals, this.value)
      this.pickerTime.updateOptions({
        restrictions: {
          disabledTimeIntervals: disabledIntervals,
        }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "./node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "./node_modules/@fortawesome/fontawesome-free/scss/solid.scss";
@import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';

.date-time-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}

.date-time-label {
  color: var(--agile-purple);
  margin-bottom: 4px;
  font-family: "Neue Helvetica",sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1em;
}

.date-time-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border: 1px solid var(--agile-custom4);
  border-radius: 10px 0 0 10px;
  border-right:none;
  min-height:33px;
}
.date-time-row-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border: 1px solid var(--agile-custom4);
  border-radius: 0 10px 10px 0;
  border-left:none;
  min-height:33px;
}

.separated-date-time-symbol {
  margin-right: 5px;
}

.separated-date-input,
.separated-time-input {
  width: 100%;
  background-color: transparent;
  color: var(--agile-purple);
}

.no-gap-form-group ::v-deep {
  legend {
    padding-bottom: 0 !important;
    margin-bottom: 4px;
    color: #00168d;
    font-family: "Neue Helvetica", sans-serif;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1em;
  }
}

.separated-date-time {
  display: flex;
  flex-direction: row;

  border-radius: 10px;
  height: 100%;

}

.separated-date-time-bislet {
  display: flex;
  justify-content: space-evenly;
  border-radius: 10px;
  height: 100%;
  gap: 20px;

}

.date-bislet, .time-bislet {
  width: 50%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.separated-date-time-symbol {
  //width: 12.5%;
  align-self: center;
  border-radius: 10px 0px 0px 10px;
  text-align: right;
  padding-left: 10px;
  padding-right: 7px;
}

/*
@media screen and (max-width: 471px) {
  .separated-date-time-bislet {
    flex-direction: column;
    align-items: center; !* Optional: Centers items vertically in column mode *!
  }
}
*/

.separated-date-icon {
  color: var(--agile-custom1);

  width: 11px;
  height: 12px;
  //flex: 0 0 20%;
}

.separated-time-icon {
  color: var(--agile-custom1);
  width: 12px;
  height: 12px;
  //flex: 0 0 20%;
}

.separated-date-input {

  border-radius: 0px;
  border: none;
  border-right: 1px solid var(--agile-custom4);
  color: var(--agile-purple);
  padding: 5px 5px 5px 5px;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  //flex: 0 0 30%;
  background-color: transparent;
}

.separated-time-input {
  color: var(--agile-purple);
  border-radius: 0px 10px 10px 0px;
  border: none;
  padding: 5px 5px 5px 5px;
  background-color: transparent;
}

.separated-date-input-bislet {
  width: 100%;
  border-radius: 10px;
  border: unset;
  color: var(--agile-custom1);
  padding: 5px 5px 5px 5px;
  height: 58px;

  color: var(--agile-purple);
  /* Text/Text 14 */
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}

.separated-time-input-bislet {

  width: 100%;
  border-radius: 10px;
  border: unset;
  padding: 5px 5px 5px 5px;
  height: 58px;
  /*background-color: transparent;*/

  color: var(--agile-purple);
  /* Text/Text 14 */
  font-family: Helvetica Neue;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}


</style>
